export default {
	ITEMCELL: 'itemCell',
	FOLDERCELL: 'folderCell',
	// SIDENAVSECTION: 'sideNavSection',
}
